import "./AdAuction.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest.js";
import { ScaleLoader } from "react-spinners";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { MdAdd, MdAlternateEmail, MdClose, MdDelete, MdEdit, MdForum, MdOutlineMenuOpen, MdPersonAddAlt1, MdPhone, MdPublishedWithChanges, MdSave } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { IoDocumentTextSharp } from "react-icons/io5";
import { fetchClientsBySearch, fetchUsersBySearch, logData, removeSpacesAndTabs, trimString } from "../../../utils/genericFunctions.js";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import Collaborator from "../../../components/Collaborator/Collaborator.jsx";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { RiAttachment2 } from "react-icons/ri";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import { IoMdInformationCircle } from "react-icons/io";
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import { LucideListCollapse } from "lucide-react";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import { FaPeopleRoof } from "react-icons/fa6";


// --- small helpers ---
const initials = (name = "") =>
    name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() || "")
        .join("");

const fmtDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    });
};


const splitDuration = (totalSeconds = 0) => {
    const s = Math.max(0, Math.floor(totalSeconds));
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    return { d, h, m, s: sec };
};


const AdAuction = () => {
    const { t } = useTranslation();
    const { docid } = useParams();
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const navigate = useNavigate();

    const participantRef = useRef(null);
    const watcherRef = useRef(null);

    const actionsMenuRef = useRef(null);
    const [openOptions, setOpenOptions] = useState(false);


    const [isLoading, setIsLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        action_invoked: "",
    });

    const [traceData, setTraceData] = useState([]);


    const [isDirty, setIsDirty] = useState(false);
    const [documentEnabled, setDocumentEnabled] = useState("Y");
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);

    const [validationMsgDialog, setValidationMsgDialog] = useState(false);
    const [validationMessagesResult, setValidationMessagesResult] = useState({});

    const [isCollabOpen, setIsCollabOpen] = useState(false);
    const openCollab = () => setIsCollabOpen(true);
    const closeCollab = () => setIsCollabOpen(false);
    const pageShellRef = useRef(null);
    const [collabRightOffset, setCollabRightOffset] = useState(0);

    const [auctionParticipants, setAuctionParticipants] = useState([]);
    const [selectedParticipant, setSelectedParticipant] = useState(null);

    const [auctionWatchers, setAuctionWatchers] = useState([]);
    const [selectedWatcher, setSelectedWatcher] = useState(null);

    const [nextAction, setNextAction] = useState("Validate");
    const [auctionData, setAuctionData] = useState(null);
    const [attachmentsData, setAttachmentsData] = useState([]);

    // Vehicle valuation
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [vehicleValuationArray, setVehicleValuationArray] = useState([]);

    // Risk inspection
    const [selectedInspectionRisk, setSelectedInspectionRisk] = useState(null);
    const [riskInspectionArray, setRiskInspectionArray] = useState([]);

    // Claim investigation
    const [selectedInvestigation, setSelectedInvestigation] = useState(null);
    const [claimInvestigationArray, setClaimInvestigationArray] = useState([]);

    // Legal Service
    const [selectedLegalService, setSelectedLegalService] = useState(null);
    const [legalServicesArray, setLegalServicesArray] = useState([]);
    const [definedMatterTypes, setDefinedMatterTypes] = useState(null);
    const [definedReliefSought, setDefinedReliefSought] = useState(null);

    // Risk Assement Types
    const [selectedRiskAssessment, setSelectedRiskAssessment] = useState(null);
    const [riskAssessmentArray, setRiskAssessmentArray] = useState([]);
    const [definedAssessmentTypes, setDefinedAssessmentTypes] = useState(null);
    const [definedAssessmentScopes, setDefinedAssessmentScopes] = useState(null);
    const [definedRiskFunctions, setDefinedRiskFunctions] = useState(null);

    // Asset disposal
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [assetDisposalArray, setAssetDisposalArray] = useState([]);

    const canEditPriority = useMemo(() => {
        const ownerId = auctionData?.bid_principal?._id || auctionData?.bid_principal?.usr_id || auctionData?.bid_principal?.id;
        const userId = currentUser?._id || currentUser?.usr_id || currentUser?.id;
        return ownerId && userId && String(ownerId) === String(userId);
    }, [auctionData, currentUser]);

    const [slaNowTick, setSlaNowTick] = useState(Date.now());


    const slaUi = useMemo(() => {

        const enabled = String(auctionData?.bid_sla_enabled || "N") === "Y";

        // SLA starts on publish; if not published, this will be null/undefined
        const startedAt = auctionData?.bid_sla_started_at ? new Date(auctionData.bid_sla_started_at).toISOString() : null;

        const closureDays = Math.max(0, Number(auctionData?.bid_closure_days || 0));

        // Prefer explicit deadline; else compute from startedAt + closureDays
        let deadlineAt = auctionData?.bid_closure_date ? new Date(auctionData?.bid_closure_date).getTime() : null;

        if (!deadlineAt && startedAt && closureDays > 0) {
            deadlineAt = new Date(startedAt).getTime() + closureDays * 24 * 60 * 60 * 1000;
        }

        return {
            enabled,
            startedAt,            // null if not published
            closureDays,
            deadlineAt,           // ms timestamp or null
            targetSecs: closureDays * 24 * 60 * 60, // for splitDuration reuse
            breached: String(auctionData?.bid_sla_breached || "N") === "Y",
        };
    }, [auctionData]);



    useEffect(() => {
        // Only tick when SLA has started (published)
        if (!slaUi.startedAt) return;

        const id = setInterval(() => setSlaNowTick(Date.now()), 1000);
        return () => clearInterval(id);
    }, [slaUi.startedAt]);


    useEffect(() => {
        // only tick when SLA is enabled AND not breached
        if (!slaUi.enabled || slaUi.breached) return;

        const id = setInterval(() => setSlaNowTick(Date.now()), 1000);
        return () => clearInterval(id);
    }, [slaUi.enabled, slaUi.breached]);

    const slaComputed = useMemo(() => {
        // Not published / SLA not started => show zeros
        if (!slaUi.startedAt || !slaUi.deadlineAt) {
            return {
                elapsedSecs: 0,
                remainingSecs: 0,
                breached: false,
                approaching: false,
                parts: { d: 0, h: 0, m: 0, s: 0 },
            };
        }

        const now = slaNowTick;
        const startedMs = new Date(slaUi.startedAt).getTime();
        const deadlineMs = slaUi.deadlineAt;

        const elapsedSecs = Math.max(0, Math.floor((now - startedMs) / 1000));
        const remainingSecs = Math.floor((deadlineMs - now) / 1000);

        const breached = remainingSecs <= 0;

        const totalSecs = Math.max(1, Math.floor((deadlineMs - startedMs) / 1000));
        const approaching = !breached && remainingSecs <= Math.ceil(totalSecs * 0.25);

        const parts = splitDuration(Math.abs(remainingSecs));

        return {
            elapsedSecs,
            remainingSecs,
            breached: slaUi.breached || breached,
            approaching,
            parts,
        };
    }, [slaUi.startedAt, slaUi.deadlineAt, slaUi.breached, slaNowTick]);


    const callDetailsFunction = async (serviceType) => {
        try {
            if (["Vehicle Valuation"].includes(serviceType)) {

            } else if (["Risk Inspection"].includes(serviceType)) {

            } else if (["Claims Investigation"].includes(serviceType)) {

            } else if (["Legal Service"].includes(serviceType)) {
                await fetchReliefSought();
                await fetchLegalMatterTypes();
            } else if (["Risk Assessment"].includes(serviceType)) {
                await fetchAssessmentTypes();
                await fetchAssessmentScopes();
                await fetchRiskFunctions();
            } else if (["Asset Disposal"].includes(serviceType)) {

            }
        } catch (err) {
            console.log(err);
        }
    };

    const fetchAssessmentTypes = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Assessment Types" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setDefinedAssessmentTypes(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchAssessmentScopes = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Assessment Scopes" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setDefinedAssessmentScopes(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchRiskFunctions = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Risk Categories" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setDefinedRiskFunctions(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };


    const fetchLegalMatterTypes = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Legal Matter Types" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setDefinedMatterTypes(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchReliefSought = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Legal Matter Types" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setDefinedReliefSought(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchAuction = async (firstTime = false) => {
        try {
            if (firstTime) { setIsLoading(true); }
            const res = await newRequest.get(`/auction/find/${docid}`);
            // logData("auction", res.data);
            setAuctionData(res.data);
            setAuctionParticipants(res.data?.bid_participants);
            setAuctionWatchers(res.data?.bid_watchers);

            if (res.data?.bid_vehicle_valuation) {
                setVehicleValuationArray(res.data?.bid_vehicle_valuation);
                setSelectedVehicle(res.data?.bid_vehicle_valuation[0]);
            }

            if (res.data?.bid_risk_inspection) {
                setRiskInspectionArray(res.data?.bid_risk_inspection);
                setSelectedInspectionRisk(res.data?.bid_risk_inspection[0]);
            }

            if (res.data?.bid_claims_investigation) {
                setClaimInvestigationArray(res.data?.bid_claims_investigation);
                setSelectedInvestigation(res.data?.bid_claims_investigation[0]);
            }

            if (res.data?.bid_legal_service) {
                setLegalServicesArray(res.data?.bid_legal_service);
                setSelectedLegalService(res.data?.bid_legal_service[0]);
            }

            if (res.data?.bid_risk_assessment) {
                setRiskAssessmentArray(res.data?.bid_risk_assessment);
                setSelectedRiskAssessment(res.data?.bid_risk_assessment[0]);
            }

            if (res.data?.bid_asset_disposal) {
                setAssetDisposalArray(res.data?.bid_asset_disposal);
                setSelectedAsset(res.data?.bid_asset_disposal[0]);
            }

            fetchTrace("Auction", res.data?.bid_no);
            // fetch attachments
            fetchDocumentAttachments("AD Auction", res.data._id);

            if (res.data?.bid_status === "Draft") {
                await callDetailsFunction(res.data?.bid_service_type);
            }
        } catch (err) {
            console.log(err);
        } finally {
            if (firstTime) { setIsLoading(false); }
        }
    };

    const fetchDocumentAttachments = async (docType, docid) => {
        try {
            const res = await newRequest.post(
                "/files/findDocFiles",
                {
                    fl_doc_type: docType,
                    fl_parent_doc_id: docid,
                },
            );
            setAttachmentsData(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchTrace = async (docType, docNo) => {
        try {
            const res = await newRequest.post(
                "/trace/findDoc",
                {
                    trc_doc_type: docType,
                    trc_doc_no: docNo
                }
            );
            setTraceData(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const handleAssessmentTypeChange = (e, id, field) => {
        try {
            const newData = [...riskAssessmentArray];
            const index = newData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                if (e && e.target) {
                    // Regular input
                    newData[index][field] = e.target.value;
                } else if (e && typeof e === "object") {
                    // react-select returns the whole selected option object
                    newData[index][field] = e.value;
                }
                setRiskAssessmentArray(newData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleLegalTypeChange = (e, id, field) => {
        try {
            const newData = [...legalServicesArray];
            const index = newData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                if (e && e.target) {
                    // Regular input
                    newData[index][field] = e.target.value;
                } else if (e && typeof e === "object") {
                    // react-select returns the whole selected option object
                    newData[index][field] = e.value;
                }
                setLegalServicesArray(newData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const saveRecord = async () => {
        try {
            if (!auctionData?._id) return;
            setIsProcessing(true);
            const payload = {
                bid_priority: auctionData?.bid_priority,
                bid_proposed_max_price: auctionData?.bid_proposed_max_price,
                bid_principal: auctionData?.bid_principal,
                bid_tags: auctionData?.bid_tags,
                bid_status: auctionData?.bid_status,
                bid_summary: auctionData?.bid_summary,
                bid_vehicle_valuation: vehicleValuationArray || [],
                bid_risk_inspection: riskInspectionArray || [],
                bid_claims_investigation: claimInvestigationArray || [],
                bid_legal_service: legalServicesArray || [],
                bid_risk_assessment: riskAssessmentArray || [],
                bid_asset_disposal: assetDisposalArray || [],
            };
            await newRequest.put(`/auction/upd/${auctionData._id}`, payload);
            setIsProcessing(false);
            showToast(t('updated'), "success");
        } catch (err) {
            console.log(err);
        } finally {
            setIsProcessing(false);
        }
    };

    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "publishBid") {
                setIsProcessing(true);

                const isValid = validateBid();

                if (!isValid) {
                    setIsProcessing(false);
                    return;   // STOP publish
                }

                // CALL BACKEND PUBLISH
                await newRequest.post(`/auction/publish/${auctionData?._id}`);
                navigate(`/bids/${auctionData?._id}`, { replace: true });
                showToast("Published", "success");
            } else if (confirmDialogAction === "resetBid") {
                setIsProcessing(true);
                await newRequest.put(`/auction/upd/${auctionData._id}`, { bid_status: "Draft" });
                await fetchAuction();
                navigate(`/bids/${auctionData?._id}`, { replace: true });
                setIsProcessing(false);
                showToast(t('updated'), "success");
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsProcessing(false);
            setIsConfirmDialogOpen(false);
        }
    };


    const validateBid = () => {
        try {
            let resultMsgList = [];

            for (let i = 0; i < auctionParticipants?.length; i++) {
                if (!auctionParticipants[i].contact_email) {
                    resultMsgList.push({
                        msg_index: i,
                        msg_no: `ERR${i}`,
                        msg_title: "Missing email",
                        msg_text: `<b>${auctionParticipants[i].ent_name}</b> does not have email. Please specify.`,
                        msg_type: "missing_information",
                    });
                }
            }

            if (resultMsgList.length > 0) {
                setValidationMessagesResult({
                    result_status: "error",
                    result_msg: `Some issues occurred while validating the bid. Some limits are restricted by your <b>${currentUser?.profile_name_xx}</b>. Contact administrator if you need to adjust these limits in auction module.`,
                    result_msg_list: resultMsgList,
                });

                setValidationMsgDialog(true);
                return false;
            }

            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };



    const handlePartInputChange = (rowId, field, value) => {
        setAuctionParticipants((prev) =>
            prev.map((p) => (p._id === rowId ? { ...p, [field]: value } : p))
        );
    };

    const updateParticipantField = async (row, field, rawValue) => {
        const cleaned =
            field === "contact_email"
                ? removeSpacesAndTabs(rawValue).toLowerCase()
                : removeSpacesAndTabs(rawValue);

        handlePartInputChange(row._id, field, cleaned);

        await newRequest.put(
            `/auction/updateParticipant/${auctionData?._id}`,
            {
                ent_code: row.ent_code,
                [field]: cleaned
            }
        );
    };

    const updateAuctionField = (field, value) => {
        setAuctionData(prev => ({ ...prev, [field]: value }));
    };

    // add member
    const addWatcher = async (opt) => {
        try {

            if (!auctionData?._id) return;
            if (!opt?.value) return;
            logData("opt", opt);
            const res = await newRequest.post(`/auction/addWatcher/${auctionData._id}`, {
                user_id: String(opt?.value)
            });

            if (res.data?.msg === "added") {
                setAuctionWatchers((prevParams) => [...prevParams, res.data?.doc]);
                setSelectedWatcher(null);
                if (watcherRef.current) {
                    watcherRef.current?.focus();
                }
                showToast(t('added'), "success");
            } else if (res.data?.msg === "exists") {
                showToast(`${opt?.usr_full_name} is already a watcher`, "warning");
                setSelectedWatcher(null);
                if (watcherRef.current) {
                    watcherRef.current?.focus();
                }
            } else {
                showToast(t('error'), "error");
            }
        } catch (e) {
            console.error(e);
            showToast("Failed to add member", "error");
        }
    };


    useEffect(() => {
        function handleClickOutside(event) {
            // for hiding actions menu
            if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
                setOpenOptions(false);
            }
        }

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const compute = () => {
            const el = pageShellRef.current;
            if (!el) return;

            const rect = el.getBoundingClientRect();
            // how much “empty space” exists on the right side of the centered/max-width container
            const offset = Math.max(0, window.innerWidth - rect.right);
            setCollabRightOffset(offset);
        };

        compute();

        window.addEventListener("resize", compute);
        // optional: if your layout can shift on scroll due to sticky headers etc.
        window.addEventListener("scroll", compute, true);

        return () => {
            window.removeEventListener("resize", compute);
            window.removeEventListener("scroll", compute, true);
        };
    }, []);

    useEffect(() => {
        fetchAuction(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <motion.div
                    className="ad-auction"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="auction-navbar">
                        <div className="auction-navbar-left">
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                                <span className="page-title">{auctionData?.bid_no || t('auction')}</span>
                                <div className={`auction-pill ${trimString(auctionData?.bid_status).toLowerCase()}`}>
                                    {auctionData?.bid_status || "Draft"}
                                </div>
                            </div>
                            <div className="auction-breadcrumbs">
                                <span className="auction-breadcrumb">{auctionData?.bid_service_type || "—"}</span>
                                <span className="auction-breadcrumb-sep">›</span>
                                <span className="auction-breadcrumb">{auctionData?.bid_priority || "—"} {t('priority')}</span>
                                <span className="auction-breadcrumb-sep">›</span>
                                <span className="auction-breadcrumb">{auctionData?.bid_no || "—"}</span>
                            </div>
                        </div>
                        <div className="auction-navbar-right">
                            {auctionData?.bid_status === "Draft" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#43A047"
                                    tooltip="Publish bid"
                                    endIcon={<MdPublishedWithChanges />}
                                    onClick={() => {
                                        try {
                                            if (auctionParticipants?.length === 0) {
                                                setNotifyDialogTitle("Note!");
                                                setNotifyDialogText(`You must select participants`);
                                                setIsNotifyDialogOpen(true);
                                                return;
                                            }
                                            setConfirmationActiontext(`Do you want to publish this bid ${auctionData?.bid_no}?<br/><br/>Please note that participants will be notified via email once you publish`);
                                            setConfirmDialogAction("publishBid");
                                            setIsConfirmDialogOpen(true);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}>
                                    {t('publish')}
                                </CustomLoadingButton>
                            )}
                            {auctionData?.bid_status === "Draft" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#00D37F"
                                    tooltip="Save changes"
                                    endIcon={<MdSave />}
                                    onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                            )}
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#2563EB"
                                tooltip="Run reports for this document"
                                endIcon={<IoDocumentTextSharp />}
                                onClick={() => setReportsDialogOpen(true)}>
                                {t('reports')}
                            </CustomLoadingButton>
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#f55656"
                                tooltip="Close this document"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>

                            {!["Closed", "Cancelled"].includes(auctionData?.bid_status) &&
                                <div className="icon-container"
                                    ref={actionsMenuRef}
                                    onClick={(e) => {
                                        try {
                                            e.stopPropagation();
                                            setOpenOptions(!openOptions)
                                        } catch (error) {
                                            console.log(error)
                                        }
                                    }}>
                                    <MdOutlineMenuOpen className="icon" />
                                    {openOptions && (
                                        <div className="dropdown">
                                            {["Draft"].includes(auctionData?.bid_status) &&
                                                <div className="dropdown-item"
                                                    onClick={() => {
                                                        try {
                                                            if (auctionParticipants?.length === 0) {
                                                                setNotifyDialogTitle("Note!");
                                                                setNotifyDialogText(`You must select participants`);
                                                                setIsNotifyDialogOpen(true);
                                                                return;
                                                            }
                                                            setConfirmationActiontext(`Do you want to publish this bid ${auctionData?.bid_no}?<br/><br/>Please note that participants will be notified via email once you publish`);
                                                            setConfirmDialogAction("publishBid");
                                                            setIsConfirmDialogOpen(true);
                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}
                                                >{`${t('publish')} ${t('bid')}`}</div>}
                                            {["Draft", "Published"].includes(auctionData?.bid_status) &&
                                                <div className="dropdown-item"
                                                    onClick={
                                                        () => {

                                                        }}
                                                >{`${t('cancel')} ${t('bid')}`}</div>}
                                            {["Published"].includes(auctionData?.bid_status) &&
                                                <div className="dropdown-item"
                                                    onClick={() => { }}
                                                >{`${t('close')} ${t('bid')}`}</div>}
                                            {["Published"].includes(auctionData?.bid_status) &&
                                                <div className="dropdown-item"
                                                    onClick={() => {
                                                        try {
                                                            setConfirmDialogAction("resetBid");
                                                            setConfirmationActiontext(`Do you want to reset this bid?<br/><br/>Please note resetting the bid takes it back to draft`);
                                                            setIsConfirmDialogOpen(true);
                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}
                                                >{`${t('reset')} ${t('bid')}`}</div>}
                                        </div>
                                    )}
                                </div>}

                            <div className="collaborator-icon"
                                onClick={openCollab}>
                                <MdForum className="icon" />
                            </div>
                        </div>
                    </div>
                    <div className="auction-category-content">
                        <div className="auction-content-wrapper">
                            <div className="auction-left-wrapper">
                                <div className="auction-header">
                                    <div className="auction-header-left">
                                        <h1 className="auction-title">{auctionData?.bid_title || "—"}</h1>
                                        <div className="auction-meta-row">
                                            <div className="auction-meta-user">
                                                <div className="auction-avatar small">
                                                    {auctionData?.bid_principal?.usr_photo_url ? (
                                                        <img src={auctionData.bid_principal.usr_photo_url} alt="" className="auction-avatar-img" />
                                                    ) : (
                                                        <span className="auction-avatar-initials">
                                                            <InitialsAvatar
                                                                name={auctionData?.bid_principal?.usr_full_name || "System"}
                                                                size={32}
                                                                currentTheme={currentTheme}
                                                            />
                                                        </span>
                                                    )}
                                                </div>
                                                <span className="auction-meta-text">
                                                    {t('principal')}{" "} <b>{auctionData?.bid_principal?.usr_full_name || "System"}</b>
                                                </span>
                                            </div>
                                            <div className="auction-meta-dot" />
                                            <span className="auction-meta-text">
                                                {`${t('created')} ${fmtDate(auctionData?.createdAt)}`}
                                            </span>
                                            <div className="auction-pill priority">
                                                {t('priority').toUpperCase()}: {auctionData?.bid_priority || "Normal"}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Detailed Description */}
                                <ExpandableComponent
                                    title={<div className="auction-card-block-title">
                                        <IoMdInformationCircle className="auction-card-block-icon" />
                                        <span>{t('detailedDesc')}</span>
                                    </div>}
                                    subtitle={""}
                                    defaultExpanded={true}
                                >
                                    <div className="auction-card-block-body">
                                        <div className="input-item-with-label" style={{ width: "100%", marginBottom: "10px" }}>
                                            {auctionData?.bid_status === "Draft" &&
                                                <label
                                                    className="form-dropdown-label"
                                                    style={{ width: "100px" }}
                                                >
                                                    {t('description')}
                                                </label>}
                                            {auctionData?.bid_status === "Draft" ?
                                                <textarea
                                                    id="bid_summary"
                                                    name="bid_summary"
                                                    type="text"
                                                    placeholder={t('text')}
                                                    className="form-input-item table"
                                                    style={{ width: "100%" }}
                                                    rows={3}
                                                    value={auctionData?.bid_summary}
                                                    onChange={(e) => updateAuctionField('bid_summary', e.target.value)}
                                                /> :
                                                <p className="auction-description">{auctionData?.bid_summary || "—"}</p>
                                            }
                                        </div>

                                        {/* VEHICLE VALUATION VIEW */}
                                        {auctionData?.bid_service_type === "Vehicle Valuation" && <> </>}

                                        {/* RISK INSPECTION VIEW */}
                                        {auctionData?.bid_service_type === "Risk Inspection" && <> </>}

                                        {/* CLAIM INVESTIGATION VIEW */}
                                        {auctionData?.bid_service_type === "Claims Investigation" && <> </>}

                                        {/* LEGAL SERVICE VIEW */}
                                        {auctionData?.bid_service_type === "Legal Service" && <>
                                            {legalServicesArray?.map((row) => (
                                                <div
                                                    className={`risk-card
                                                    ${legalServicesArray?.length > 1 ? "interactive" : ""}
                                                    ${selectedLegalService?._id === row._id ? "risk-card" : ""}`}
                                                    key={row?._id}
                                                    onClick={() => setSelectedLegalService(row)}>
                                                    <div className="risk-card-body">
                                                        <div className="risk-main">
                                                            <div className="risk-main-row">
                                                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                    <label
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "100px" }}
                                                                    >
                                                                        {t('type')}
                                                                    </label>
                                                                    <Select
                                                                        id={`matter_type_${row?._id}`}
                                                                        name={`matter_type_${row?._id}`}
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="100%"
                                                                        isSearchable={true}
                                                                        placeholder={t('type')}
                                                                        options={definedMatterTypes}
                                                                        value={auctionData?.bid_status !== "Draft" ? { value: row?.matter_type, label: row?.matter_type_xx } :
                                                                            definedMatterTypes?.find(option => option.value === row?.matter_type) || row?.matter_type_xx}
                                                                        onChange={(selectedOption) => handleLegalTypeChange(selectedOption, row?._id, 'matter_type')}
                                                                        isDisabled={auctionData?.bid_status !== "Draft"}
                                                                    />
                                                                </div>
                                                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                    <label
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "100px" }}
                                                                    >
                                                                        {t('relief')}
                                                                    </label>
                                                                    <Select
                                                                        id={`scope_${row?._id}`}
                                                                        name={`scope_${row?._id}`}
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="100%"
                                                                        isSearchable={true}
                                                                        placeholder={t('relief_sought')}
                                                                        options={definedReliefSought}
                                                                        value={auctionData?.bid_status !== "Draft" ? { value: row?.relief_sought, label: row?.relief_sought_xx } :
                                                                            definedReliefSought?.find(option => option.value === row?.relief_sought) || null}
                                                                        onChange={(selectedOption) => handleLegalTypeChange(selectedOption, row?._id, 'relief_sought')}
                                                                        isDisabled={auctionData?.bid_status !== "Draft"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="risk-main-row">
                                                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                    <label
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "100px" }}
                                                                    >
                                                                        {t('claimNo')}
                                                                    </label>
                                                                    <input
                                                                        id={`claim_no_${row?._id}`}
                                                                        name={`claim_no_${row?._id}`}
                                                                        type="text"
                                                                        value={row?.claim_no}
                                                                        onChange={(e) => handleLegalTypeChange(e, row?._id, 'claim_no')}
                                                                        style={{ width: "100%" }}
                                                                        className="form-input-item"
                                                                        disabled={auctionData?.bid_status !== "Draft"}
                                                                    />
                                                                </div>
                                                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                    <label
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "100px" }}
                                                                    >
                                                                        {t('caseRef')}
                                                                    </label>
                                                                    <input
                                                                        id={`case_ref_${row?._id}`}
                                                                        name={`case_ref_${row?._id}`}
                                                                        type="text"
                                                                        value={row?.case_ref}
                                                                        onChange={(e) => handleLegalTypeChange(e, row?._id, 'case_ref')}
                                                                        style={{ width: "100%" }}
                                                                        className="form-input-item"
                                                                        disabled={auctionData?.bid_status !== "Draft"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                <label
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "90px" }}
                                                                >
                                                                    {t('remarks')}
                                                                </label>
                                                                <input
                                                                    id={`remarks_${row?._id}`}
                                                                    name={`remarks_${row?._id}`}
                                                                    type="text"
                                                                    value={row?.remarks}
                                                                    onChange={(e) => handleLegalTypeChange(e, row?._id, 'remarks')}
                                                                    style={{ width: "100%" }}
                                                                    className="form-input-item"
                                                                    disabled={auctionData?.bid_status !== "Draft"}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </>}
                                        {/* RISK ASSESMENT VIEW */}
                                        {auctionData?.bid_service_type === "Risk Assessment" &&
                                            <>
                                                {riskAssessmentArray?.map((row, index) => (
                                                    <div
                                                        className={`risk-card
                                                            ${riskAssessmentArray?.length > 1 ? "interactive" : ""}
                                                            ${selectedRiskAssessment?._id === row._id ? "current" : ""}`}
                                                        key={row?._id}
                                                        onClick={() => setSelectedRiskAssessment(row)}>
                                                        <div className="risk-card-body">
                                                            <div className="risk-main">
                                                                <div className="risk-main-row">
                                                                    <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                        <label
                                                                            className="form-dropdown-label"
                                                                            style={{ width: "100px" }}
                                                                        >
                                                                            {t('type')}
                                                                        </label>
                                                                        <Select
                                                                            id={`type_${row?._id}`}
                                                                            name={`type_${row?._id}`}
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="100%"
                                                                            isSearchable={true}
                                                                            placeholder={t('type')}
                                                                            options={definedAssessmentTypes}
                                                                            value={auctionData?.bid_status !== "Draft" ? { value: row?.assessment_type, label: row?.assessment_type_xx } :
                                                                                definedAssessmentTypes?.find(option => option.value === row?.assessment_type) || null}
                                                                            onChange={(selectedOption) => handleAssessmentTypeChange(selectedOption, row?._id, 'assessment_type')}
                                                                            isDisabled={auctionData?.bid_status !== "Draft"}
                                                                        />
                                                                    </div>

                                                                    <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                        <label
                                                                            className="form-dropdown-label"
                                                                            style={{ width: "100px" }}
                                                                        >
                                                                            {t('scope')}
                                                                        </label>
                                                                        <Select
                                                                            id={`scope_${row?._id}`}
                                                                            name={`scope_${row?._id}`}
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="100%"
                                                                            isSearchable={true}
                                                                            placeholder={t('scope')}
                                                                            options={definedAssessmentScopes}
                                                                            value={auctionData?.bid_status !== "Draft" ? { value: row?.assessment_scope, label: row?.assessment_scope_xx } :
                                                                                definedAssessmentScopes?.find(option => option.value === row?.assessment_scope) || null}
                                                                            onChange={(selectedOption) => handleAssessmentTypeChange(selectedOption, row?._id, 'assessment_scope')}
                                                                            isDisabled={auctionData?.bid_status !== "Draft"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="risk-main-row">
                                                                    <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                        <label
                                                                            className="form-dropdown-label"
                                                                            style={{ width: "100px" }}
                                                                        >
                                                                            {t('function')}
                                                                        </label>
                                                                        <Select
                                                                            id={`function_${row?._id}`}
                                                                            name={`function_${row?._id}`}
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="100%"
                                                                            isSearchable={true}
                                                                            placeholder={t('function')}
                                                                            options={definedRiskFunctions}
                                                                            value={auctionData?.bid_status !== "Draft" ? { value: row?.risk_function, label: row?.risk_function_xx } :
                                                                                definedRiskFunctions?.find(option => option.value === row?.risk_function) || null}
                                                                            onChange={(selectedOption) => handleAssessmentTypeChange(selectedOption, row?._id, 'risk_function')}
                                                                            isDisabled={auctionData?.bid_status !== "Draft"}
                                                                        />
                                                                    </div>
                                                                    <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                        <label
                                                                            className="form-dropdown-label"
                                                                            style={{ width: "100px" }}
                                                                        >
                                                                            {t('address')}
                                                                        </label>
                                                                        <input
                                                                            id={`address_${row?._id}`}
                                                                            name={`address_${row?._id}`}
                                                                            type="text"
                                                                            value={row?.risk_address}
                                                                            onChange={(e) => handleAssessmentTypeChange(e, row?._id, 'risk_address')}
                                                                            style={{ width: "100%" }}
                                                                            className="form-input-item"
                                                                            disabled={auctionData?.bid_status !== "Draft"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                                                    <label
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "90px" }}
                                                                    >
                                                                        {t('remarks')}
                                                                    </label>
                                                                    <input
                                                                        id={`remarks_${row?._id}`}
                                                                        name={`remarks_${row?._id}`}
                                                                        type="text"
                                                                        value={row?.remarks}
                                                                        onChange={(e) => handleAssessmentTypeChange(e, row?._id, 'remarks')}
                                                                        style={{ width: "100%" }}
                                                                        className="form-input-item"
                                                                        disabled={auctionData?.bid_status !== "Draft"}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>))}
                                            </>}


                                        {/* ASSET DISPOSAL VIEW */}
                                        {auctionData?.bid_service_type === "Asset Disposal" && <> </>}


                                    </div>
                                </ExpandableComponent>
                                <ExpandableComponent
                                    title={
                                        <div className="auction-card-block-title">
                                            <FaPeopleRoof className="auction-card-block-icon" />
                                            <span>{`${auctionParticipants?.length} ${auctionParticipants?.length === 1 ? t('participant').toUpperCase() : t('participants').toUpperCase()}`}</span>
                                        </div>
                                    }
                                    subtitle={
                                        ["Draft"].includes(auctionData?.bid_status) &&
                                        <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                                            <AsyncSelect
                                                ref={participantRef}
                                                id="participant"
                                                name="participant"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    })
                                                }}
                                                isClearable
                                                width="375px"
                                                value={selectedParticipant}
                                                onChange={(selectedOption) => setSelectedParticipant(selectedOption)}
                                                loadOptions={fetchClientsBySearch}
                                                isSearchable={true}
                                                placeholder={t('participant')}
                                                noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                            />
                                            <CircularButton
                                                currentTheme={currentTheme}
                                                onClick={async (e) => {
                                                    try {

                                                        if (!selectedParticipant) {
                                                            setNotifyDialogTitle("Note!");
                                                            setNotifyDialogText(`Please select participant`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }

                                                        const res = await newRequest.post(`/auction/addParticipant/${auctionData?._id}`, { ent_code: selectedParticipant?.ent_code });


                                                        if (res.data?.msg === "added") {
                                                            setAuctionParticipants((prevParams) => [...prevParams, res.data?.doc]);
                                                            setSelectedParticipant(null);
                                                            if (participantRef.current) {
                                                                participantRef.current?.focus();
                                                            }
                                                            showToast(t('added'), "success");
                                                        } else if (res.data?.msg === "exists") {
                                                            showToast(`${selectedParticipant?.label?.props?.children[0]} is already a participant`, "warning");
                                                            setSelectedParticipant(null);
                                                            if (participantRef.current) {
                                                                participantRef.current?.focus();
                                                            }
                                                        } else {
                                                            showToast(t('error'), "error");
                                                        }
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                                icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                        </span>}
                                    defaultExpanded={auctionParticipants?.length > 0}
                                >
                                    <div className="participants-content">
                                        {auctionParticipants?.length > 0 &&
                                            <div className="participants-wrapper">
                                                {auctionParticipants?.map((row, index) => (
                                                    <div key={row._id} className='single-participant'>
                                                        <div className="single-participant-left">
                                                            {row?.ent_photo_url ?
                                                                <img src={row?.ent_photo_url} alt="" className="img" />
                                                                : <InitialsAvatar
                                                                    name={row?.ent_name}
                                                                    size={60}
                                                                    currentTheme={currentTheme}
                                                                />}
                                                        </div>
                                                        <div className="single-participant-right">
                                                            <div className="single-participant-header">
                                                                <span className='participant-name'>{row?.ent_name}</span>
                                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "3px" }}>
                                                                        <span className="relationship-type">{row?.participant_status}</span>
                                                                        <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.sent_on_xx}</span>
                                                                    </div>
                                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                                                        <span className={`auction-pill ${trimString(row?.invite_status).toLowerCase()}`}>
                                                                            <span>{`${t('inviteStatus')} ${row?.invite_status}`}</span>
                                                                        </span>
                                                                        {["Draft"].includes(auctionData?.bid_status) &&
                                                                            <CircularButton
                                                                                currentTheme={currentTheme}
                                                                                color="#F44336"
                                                                                onClick={async () => {
                                                                                    try {
                                                                                        setIsProcessing(true);
                                                                                        const res = await newRequest.post(
                                                                                            `/auction/removeParticipant/${auctionData?._id}`, {
                                                                                            ent_code: row?.ent_code
                                                                                        });
                                                                                        setIsProcessing(false);
                                                                                        if (res.data?.msg === "removed") {
                                                                                            setAuctionParticipants((prev) => prev.filter(mm => mm?._id !== row?._id));
                                                                                            showToast("Removed!", "success");
                                                                                        } else {
                                                                                            showToast("Error removing!", "error");
                                                                                        }
                                                                                    } catch (error) {
                                                                                        console.log(error);
                                                                                    }
                                                                                }} icon={<MdDelete />} width={"30px"} height={"30px"} />}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="participant-phone-row">
                                                                <span className="participant-phone-details" style={{ flex: "1.5" }}>
                                                                    <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                                                        <MdAlternateEmail className="icon" />
                                                                        {auctionData?.bid_status === "Draft" ?
                                                                            <input
                                                                                id={`${row._id}_contact_email`}
                                                                                name={`${row._id}_contact_email`}
                                                                                type="email"
                                                                                placeholder={t('email')}
                                                                                className="form-input-item table"
                                                                                style={{ width: "100%" }}
                                                                                value={row?.contact_email}
                                                                                onChange={(e) => {
                                                                                    try {
                                                                                        const value = e.target.value;
                                                                                        if (!value) return;
                                                                                        handlePartInputChange(row._id, 'contact_email', value);
                                                                                    } catch (error) {
                                                                                        console.log(error);
                                                                                    }
                                                                                }}
                                                                                onBlur={(e) => updateParticipantField(row, "contact_email", e.target.value)}

                                                                            /> :
                                                                            <span>{row?.contact_email}</span>
                                                                        }
                                                                    </div>
                                                                </span>
                                                                <span className="participant-phone-details" style={{ flex: "1.5" }}>
                                                                    <div className="input-item-with-label" style={{ gap: "5px" }}>
                                                                        <MdPhone className="icon" />
                                                                        {auctionData?.bid_status === "Draft" ?
                                                                            <input
                                                                                id={`${row._id}_contact_phone`}
                                                                                name={`${row._id}_contact_phone`}
                                                                                type="text"
                                                                                placeholder={t('phoneNo')}
                                                                                className="form-input-item table"
                                                                                style={{ width: "200px" }}
                                                                                value={row?.contact_phone}
                                                                                onChange={(e) => {
                                                                                    try {
                                                                                        const value = e.target.value;
                                                                                        if (!value) return;
                                                                                        handlePartInputChange(row._id, 'contact_phone', value);
                                                                                    } catch (error) {
                                                                                        console.log(error);
                                                                                    }
                                                                                }}
                                                                                onBlur={(e) => updateParticipantField(row, "contact_phone", e.target.value)}

                                                                            /> :
                                                                            <span>{row?.contact_phone}</span>
                                                                        }
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>}
                                    </div>
                                </ExpandableComponent>

                                <ExpandableComponent
                                    title={<div className="auction-card-block-title">
                                        <RiAttachment2 className="auction-card-block-icon" />
                                        <span>{t('attachments')}</span>
                                    </div>}
                                    subtitle={
                                        attachmentsData?.length > 1 ? `${attachmentsData.length} ${t('attachments')}`
                                            : attachmentsData?.length === 1 ? `${attachmentsData.length} ${t('attachment')}`
                                                : t('noAttachments')}
                                    defaultExpanded={attachmentsData?.length > 0 ? true : false}
                                >
                                    <div className="attachments">
                                        {!["Closed", "Cancelled"].includes(auctionData?.bid_status) &&
                                            <FileUploadComponent documentNo={auctionData?.bid_no}
                                                documentId={auctionData?._id}
                                                documentType="AD Auction"
                                                fetchDocumentAttachments={fetchDocumentAttachments}
                                                uploadFolder={`ad-auction/${auctionData?._id}`}
                                            />}
                                        <div className="attachment-files">
                                            <AllFiles filesList={attachmentsData} allowDelete={auctionData?.bid_principal?._id === currentUser?._id ? "Y" : "N"} />
                                        </div>
                                    </div>
                                </ExpandableComponent>
                                {/* Activity & Collaboration */}
                                <ExpandableComponent
                                    title={<div className="auction-card-block-title">
                                        <LucideListCollapse className="auction-activity-icon" />
                                        <span>{t('activityAndCollab')}</span>
                                    </div>}
                                    subtitle={""}
                                    defaultExpanded={true}
                                >
                                    <AllDocsNote
                                        docId={auctionData?._id}
                                        docType="Auction"
                                        noteType={"Normal"}
                                    />
                                </ExpandableComponent>
                            </div>
                            <div className="auction-right-wrapper">
                                {/* TIME TO RESOLVE */}
                                <div className="auction-side-card">
                                    <div className="auction-side-card-top">
                                        <div className="auction-side-label">{t("timeToClose").toUpperCase()}</div>
                                        <div className="auction-side-time">
                                            {/* DAYS (show if > 24h remaining OR > 24h breached) */}
                                            {(slaComputed.parts.d > 0) && (
                                                <>
                                                    <motion.span
                                                        key={`d-${slaComputed.parts.d}`}
                                                        className="num"
                                                        initial={{ y: -6, opacity: 0.6 }}
                                                        animate={{ y: 0, opacity: 1 }}
                                                        transition={{ duration: 0.18 }}
                                                    >
                                                        {String(slaComputed.parts.d).padStart(2, "0")}
                                                    </motion.span>
                                                    <span className="unit">d</span>
                                                </>
                                            )}

                                            {/* HOURS */}
                                            <span className="num">{String(slaComputed.parts.h).padStart(2, "0")}</span>
                                            <span className="unit">h</span>

                                            {/* MINUTES */}
                                            <span className="num">{String(slaComputed.parts.m).padStart(2, "0")}</span>
                                            <span className="unit">m</span>

                                            {/* SECONDS (only before breach). Dont show if days is showing */}
                                            {slaComputed.parts.d === 0 &&
                                                !slaComputed.breached && (
                                                    <>
                                                        <motion.span
                                                            key={`s-${slaComputed.parts.s}`} // re-animates every second
                                                            className="num secs"
                                                            initial={{ scale: 0.92, opacity: 0.65 }}
                                                            animate={{ scale: 1, opacity: 1 }}
                                                            transition={{ duration: 0.12 }}
                                                        >
                                                            {String(slaComputed.parts.s).padStart(2, "0")}
                                                        </motion.span>
                                                        <span className="unit">s</span>
                                                    </>
                                                )}
                                        </div>

                                        {(slaComputed.approaching || slaComputed.breached) && (
                                            <div className={`auction-side-alert ${slaComputed.breached ? "breached" : "approaching"}`}>
                                                {slaComputed.breached ? t("breached").toUpperCase() : t("approachingBreach").toUpperCase()}
                                            </div>
                                        )}
                                    </div>

                                    <div className="auction-side-divider" />

                                    <div className="auction-side-grid">
                                        <div className="auction-side-row">
                                            <div className="auction-side-small-label">{t('slaCategory').toUpperCase()}</div>
                                            <div className="auction-side-strong">
                                                {auctionData?.bid_priority === "Critical"
                                                    ? "Critical (P1)"
                                                    : auctionData?.bid_priority === "Urgent"
                                                        ? "Urgent (P2)"
                                                        : "Standard"}
                                            </div>
                                        </div>

                                        <div className="auction-side-row split">
                                            <div>
                                                <div className="auction-side-small-label">{t('targetToResolutionTime').toUpperCase()}</div>
                                                <div className="auction-side-strong">
                                                    {slaUi.target > 0 ? `${Math.round(slaUi.target / 60)} Hours` : "—"}
                                                </div>
                                            </div>
                                            <div className="auction-side-right-muted">
                                                {slaUi.startedAt ? `Started ${auctionData?.time_ago_xx || ""}` : ""}
                                            </div>
                                        </div>

                                        <div className="auction-side-row split">
                                            <div>
                                                <div className="auction-side-small-label first">{t('firstResponse').toUpperCase()}</div>
                                                <div className="auction-side-pill met">Met</div>
                                            </div>
                                            <div>
                                                <div className="auction-side-small-label">{t('resolution').toUpperCase()}</div>
                                                <div className="auction-side-pill active">
                                                    {auctionData?.bid_status === "Resolved" || auctionData?.bid_status === "Closed"
                                                        ? "Met"
                                                        : "Active"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* WATCHERS */}
                                <div className="auction-side-card">
                                    <div className="auction-side-card-header">
                                        <div className="auction-side-title">{t('activeWatchers').toUpperCase()}</div>
                                        <div className="auction-side-count">{auctionWatchers?.length}</div>
                                    </div>

                                    <div className="auction-watchers-row">
                                        <div className="auction-watchers-avatars">
                                            {auctionWatchers?.slice(0, 3).map((w) => (
                                                <div className="auction-avatar tiny" key={w.id}>
                                                    {w.usr_photo_url ? (
                                                        <img src={w.usr_photo_url} alt="" className="auction-avatar-img" />
                                                    ) : (
                                                        <span className="auction-avatar-initials">{initials(w?.usr_full_name || "U")}</span>
                                                    )}
                                                </div>
                                            ))}
                                            {auctionWatchers?.length > 3 && (
                                                <div className="auction-avatar tiny more">
                                                    <span className="auction-avatar-initials">+{auctionWatchers?.length - 3}</span>
                                                </div>
                                            )}
                                        </div>

                                        {/* <button type="button" className="auction-icon-btn">
                                            <MdPersonAddAlt1 />
                                        </button> */}
                                    </div>

                                    {!["Closed", "Cancelled"].includes(auctionData?.bid_status) &&
                                        <div className="auction-watcher-search">
                                            <AsyncSelect
                                                ref={watcherRef}
                                                id="watcher"
                                                name="watcher"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                                value={selectedWatcher}
                                                onChange={(opt) => {
                                                    setSelectedWatcher(opt);
                                                    addWatcher(opt);
                                                }}
                                                loadOptions={(inputValue, callback) =>
                                                    fetchUsersBySearch(inputValue, callback, ["Internal"])
                                                }
                                                width={"100%"}
                                                height={"32px"}
                                                isSearchable
                                                placeholder={t("watcher")}
                                                noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                                            />
                                        </div>}
                                </div>

                                {/* PROPERTIES */}
                                <div className="auction-side-card">
                                    <div className="timeline-title">{t('timeline').toUpperCase()}</div>
                                    <div className="timeline-root">
                                        {traceData.map((item) => (
                                            <div key={item?._id} className="timeline-item">
                                                <div className="timeline-separator">
                                                    <div className="timeline-dot"></div>
                                                    <div className="timeline-connector" />
                                                </div>
                                                <div className="timeline-content">
                                                    <div className="timeline-navbar">
                                                        <div className="avatar-container">
                                                            {item?.updated_by_photo_url_xx ?
                                                                <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" />
                                                                : <InitialsAvatar
                                                                    name={item?.updated_by_name_xx}
                                                                    size={30}
                                                                    currentTheme={currentTheme}
                                                                />}
                                                            <span className="username">{item?.updated_by_name_xx}</span>
                                                        </div>
                                                        <span className="time-ago">{item?.time_ago_xx}</span>
                                                    </div>
                                                    <div className="remarks">
                                                        {item?.trc_remarks}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Collaborator
                        open={isCollabOpen}
                        docType={"Auction"}
                        docNo={auctionData?.bid_no}
                        docId={auctionData?._id}
                        currentTheme={currentTheme}
                        onClose={closeCollab}
                        rightOffset={collabRightOffset}
                        currentUser={currentUser}
                    />
                </motion.div>
            )}

            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={["auctions"]}
                                documentData={{
                                    docNo: auctionData?.bid_no,
                                    docType: "Auction",
                                    docId: auctionData?._id,
                                    ticket_docid: auctionData?._id
                                }} />
                        </div>
                    </div>
                </motion.div>)}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle={t('confirmation')}
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
            {validationMsgDialog && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-content">
                            <ValidationMessages
                                messageData={validationMessagesResult}
                                onClose={() => setValidationMsgDialog(false)}
                                onFix={(row) => {/* focus field / navigate */ }}
                                onRemind={() => setValidationMsgDialog(false)}
                                onSupport={() => navigate("/support")}
                            />
                        </div>
                    </div>
                </motion.div>
            )}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
                        <ScaleLoader
                            color="var(--primary)"
                            height={50}
                            radius={8}
                            width={4}
                        />
                    </div>
                </motion.div>)}
        </div>
    )
}

export default AdAuction;